// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientInfo_root__1WpLw","info":"PatientInfo_info__1cXHM"};